import clsx from "clsx";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigationContext } from "web/react/components/navigation/navigation.context";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { closeSearch, openSearch } from "web/redux/ducks/app-header-bar";
import analytics from "web/script/analytics/analytics";
import * as styles from "./search-button.css";

export function SearchButton(): JSX.Element {
    const dispatch = useDispatch();
    const { isSearchOpen, setIsSearchOpen, showMenu, setShowMenu } = useNavigationContext();
    function onClick(): void {
        if (!isSearchOpen) {
            if (showMenu) {
                setShowMenu(null);
            }
            setIsSearchOpen(true);
            // Redux logic still needed for matte
            dispatch(openSearch());
        } else {
            setIsSearchOpen(false);
            dispatch(closeSearch());
        }
        analytics.event("header", "clicked", "burger_menu_search_button_open");
    }

    return (
        <button id="searchButton" onClick={onClick} className={styles.iconWrapper}>
            <SVGIcon className={clsx(styles.icon, showMenu && styles.greyIcon)} name="search-emo" />
        </button>
    );
}
